import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-skin-analysis-validator"
    exact
    path="/business/products/ai-skin-analysis-validator"
    component={AsyncPage}
  />,
];
